export default import.meta.ROLLDOWN_FILE_URL_AnoYE4vk_ie4l2$26eIjSw